// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--bZGLu","title":"_93444fe79c--title--XQnqf"};